/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-09-10 16:15:19
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-12 15:44:42
 * @FilePath: \ui\src\pages\components\ModelSelect\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useModelConfigContext } from '../../../stores/modelConfig.store'
import { Button, App as AntdApp, Dropdown } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
/* 🌟 模型选择 */

const ModelSelect: React.FC = () => {
  const { chooseModel, baseModel } = useModelConfigContext()
  const handleModelChange = (e: any) => {
    chooseModel(e.key)
  }
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1000)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const items = [

    {
      key: 'DeepSeek',
      label: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '8px',
            padding: '10px 12px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 4,
              width: ' 36px',
              height: '36px',
              backgroundColor: '#ffffff',
              borderRadius: '18px',
            }}
          >
            <img
              src="https://oss.senlaniot.com/senlaniot/%2Fsenlan-ai-agent%2Ftest-user%2Fpng%2F2025-08-12%2F2a80baae-4bd4-44c8-94e9-de24ce2594c0deepseek.png"
              alt="DeepSeek"
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div style={{ fontSize: 16, color: '#212329' }}>DeepSeek</div>
            <div style={{ fontSize: 12, color: '#494C57' }}>
              DeepSeek模型，包含V3、R1等系列模型
            </div>
          </div>
        </div>
      ),
    }, {
      key: '通义千问',
      label: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '8px',
            padding: '10px 12px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 4,
              width: ' 36px',
              height: '36px',
              backgroundColor: '#ffffff',
              borderRadius: '18px',
            }}
          >
            <img
              src="https://oss.senlaniot.com/senlaniot/%2Fsenlan-ai-agent%2Ftest-user%2Fpng%2F2025-08-12%2Fcf65c79d-52e9-4efc-a478-fb71427f050atongyi.png"
              alt="通义千问"
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div style={{ fontSize: 16, color: '#212329' }}>通义千问</div>
            <div style={{ fontSize: 12, color: '#494C57' }}>
              Qwen3模型，包含Flush、Plus系列模型
            </div>
          </div>
        </div>
      ),
    },
  ]

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleModelChange,
        selectable: false,
      }}
      placement={isMobile ? 'bottom' : 'bottomRight'}
      arrow
    >
      <Button
        type="text"
        style={{
          height: '40px',
          color: '#212329',
        }}
      >
        <img
          src={
            baseModel === '通义千问'
              ? 'https://oss.senlaniot.com/senlaniot/%2Fsenlan-ai-agent%2Ftest-user%2Fpng%2F2025-08-12%2Fcf65c79d-52e9-4efc-a478-fb71427f050atongyi.png'
              : 'https://oss.senlaniot.com/senlaniot/%2Fsenlan-ai-agent%2Ftest-user%2Fpng%2F2025-08-12%2F2a80baae-4bd4-44c8-94e9-de24ce2594c0deepseek.png'
          }
          alt=""
        />
        {baseModel} <DownOutlined />
      </Button>
    </Dropdown>
  )
}
export default ModelSelect
